import { mockPolicies } from "../mockPolicies";
import { testDriveMember } from "../mockMembers";

import { MockPersona } from "./mockPersonas.types";

export const calebCancelled: MockPersona = {
  key: "calebCancelled",
  name: "Caleb Cancelled",
  description: "🇺🇸 | One cancelled policy, no bills, no HDC",
  providerApiMockResponses: {
    cig: {
      billing: {
        fees: [],
        bills: [],
      },
      policies: {
        usa: [mockPolicies["CU723189-01"]],
        canada: [],
      },
    },
    esign: {
      fetchESignDocuments: [],
      createESignRequest: "error",
    },
    insurance: {
      fetchEndorsement: [],
    },
    soul: {
      fetchSoul: {
        hagertyAccounts: {
          myHagertyAccount: {
            id: "1",
            loginEmail: "caleb@cancelled.com",
            firstName: "Caleb",
            middleName: "",
            lastName: "Cancelled",
            mailingAddress: {
              line1: "741 Leatherwood St.",
              line2: "",
              city: "Houston",
              state: "TX",
              postalCode: "77089",
              country: "USA",
            },
            preferredPhone: "2819003845",
            salesforceAccounts: [
              {
                accountNumber: "123",
                id: "1",
                partnerId: null,
              },
            ],
            drivetrainAccounts: [
              {
                customerAccountLegacyKey: "000005",
                source: "USA",
                customerSourceSystemKey: "123",
                id: "1",
                partnerCustomerId: "123",
                partnerId: "UNKNOWN",
              },
            ],
            identityAccounts: [],
            message: undefined,
          },
        },
      },
    },
    member: {
      fetchMember: {
        member: {
          member: testDriveMember,
        },
      },
    },
    billing: {
      fetchBilling: {
        bills: {
          bills: [],
          outstandingBalance: 0,
        },
      },
    },
    payments: {
      fetchPayEndorsementUrl: { payEndorsementUrl: "mock-url" },
    },
  },
};
